module.exports = __webpack_public_path__ + "media/images/faq/brand6-205091498bf31a4c62e53f6961f58107.png";